import { normalizePoseKeyframes } from './format'
import { compareStory } from './storyTime'
import type { NumberKeyframe, PoseKeyframe, StatusKeyframe, VisibilityKeyframe } from './types'

export function sortNumberFrames(frames: NumberKeyframe[]): NumberKeyframe[] {
  return [...frames].sort((a, b) => compareStory(a.at, b.at))
}

export function sortPoseFrames(frames: PoseKeyframe[]): PoseKeyframe[] {
  return normalizePoseKeyframes(frames)
}

export function sortStatusFrames(frames: StatusKeyframe[]): StatusKeyframe[] {
  return [...frames].sort((a, b) => compareStory(a.at, b.at))
}

export function sortVisFrames(frames: VisibilityKeyframe[]): VisibilityKeyframe[] {
  return [...frames].sort((a, b) => compareStory(a.at, b.at))
}

export const MAP_LABEL_MAX_CHARS = 30
